import { eq } from 'tio-ui/utilities';
import { Section } from 'tio-ui/components/layout';
import { t } from 'ember-intl';
import Component from '@glimmer/component';
import TableRow from './table/row.gts';
import type { CommentsMap } from '../tuition-assistance/approver-comments.ts';
import type CommentModel from 'tio-data/models/comment';
import type PersonModel from 'tio-data/models/person';

interface ApproverCommentsTableSignature {
  Args: {
    currentPerson: PersonModel;
    model: CommentsMap;
    onClose: () => void;
  };
}

export default class ApproverCommentsTableComponent extends Component<ApproverCommentsTableSignature> {
  showExpandableCommentSection = (key: string) => {
    if (key === 'programInstance' || key === 'application') {
      return false;
    }
    return true;
  };

  save = async (comment: CommentModel) => {
    if (comment.isNew) {
      this.args.onClose();
    }
    await comment.save();
  };

  rollback = async (comment: CommentModel) => {
    if (comment.isNew) {
      this.args.onClose();
      await comment.destroyRecord();
    }
    comment.rollbackAttributes();
  };

  delete = async (comment: CommentModel) => {
    await comment.destroyRecord();
  };

  <template>
    <table class="table-fixed w-full">
      <tbody>
        {{#each-in @model as |key comments|}}
          {{#if (this.showExpandableCommentSection key)}}
            <Section @collapsed={{true}}>
              <:header>
                <p class="text-wrap text-left">
                  {{t "common.tuition_assistance.comments_for_application_id"}}
                  <span class="font-semibold">{{key}}</span>
                </p>
              </:header>
              <:body>
                {{#each comments as |comment|}}
                  <TableRow
                    @model={{comment}}
                    @canEdit={{eq @currentPerson.id comment.person.id}}
                    @canDelete={{@currentPerson.user.isTioAdmin}}
                    @onSave={{this.save}}
                    @onCancel={{this.rollback}}
                    @onDelete={{this.delete}}
                  />
                {{/each}}
              </:body>
            </Section>
          {{else}}
            {{#each comments as |comment|}}
              <TableRow
                @model={{comment}}
                @canEdit={{eq @currentPerson.id comment.person.id}}
                @canDelete={{@currentPerson.user.isTioAdmin}}
                @onSave={{this.save}}
                @onCancel={{this.rollback}}
                @onDelete={{this.delete}}
              />
            {{/each}}
          {{/if}}
        {{else}}
          <tr class="bg-white h-9">
            <td colspan="3" class="px-2 text-gray-500 text-center">
              {{t "common.tuition_assistance.no_comments_found"}}
            </td>
          </tr>
        {{/each-in}}
      </tbody>
    </table>
  </template>
}
